import React from 'react';
type BonusCoverProps = {
  number: number;
  label: string;
  color: string;
};
export function BonusCover({
  number,
  label,
  color
}: BonusCoverProps) {
  return <div className="relative mx-auto w-36 shrink-0 sm:w-40" aria-hidden="true" data-id="element-16" data-mp="2yb6ztxd84t2e">
      <div className="absolute inset-y-2 -right-2 w-3 rounded-r-md bg-navy/80" data-id="element-17" data-mp="3d38v144cmxw3" />
      <div className={`relative flex aspect-[3/4] flex-col justify-between rounded-lg p-4 text-white shadow-soft ${color}`} data-id="element-18" data-mp="38afrukoj3xm4">
        <div data-id="element-19" data-mp="3m4guhpilq4rr">
          <span className="inline-block rounded-md bg-white/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide" data-id="element-20" data-mp="3i1ap0k3bchmc">
            Bonus {String(number).padStart(2, '0')}
          </span>
          <p className="mt-3 font-display text-lg font-extrabold uppercase leading-[1.05]" data-id="element-21" data-mp="3r1pb3lo3q0qw">{label}</p>
        </div>
        <div className="flex items-end justify-between" data-id="element-22" data-mp="21m93wbtqmp3n">
          <span className="font-display text-[10px] font-extrabold uppercase leading-tight" data-id="element-23" data-mp="21ovb2acpv2lc">
            Mathe
            <br data-id="element-24" data-mp="1wq0wjkls8071" />
            Bereit™
          </span>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-sun font-display text-sm font-extrabold text-navy" data-id="element-25" data-mp="2ccq88cwfcizr">
            {number}
          </span>
        </div>
      </div>
    </div>;
}